import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Pipe({
  standalone: true,
  name: 'formControl'
})
export class FormControlPipe implements PipeTransform {
  /**
   *
   * @param value
   *
   * @returns
   */
  public transform(value: AbstractControl | null): FormControl {
    return value as FormControl;
  }
}
